//全局默认配置项

//默认路由地址
export const DEFAULT_ROUTE = "/home";

//暂未开放的页面列表
export const noneOpenList = ["/teach"];

//埋点统计路由列表
export const trackStatisticList = ["/secondary/grade", "/secondary/setting", "/flight/guide"];

//登录系统的地址
export const AUTH = "/gateway/unpapi/uotssimulator/oauth2";

export const tokenStr = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiIxODk2ODA5NzA0NDY3MzIwODMyIiwibmJmIjoxNzkzNjA5MzE2LCJleHAiOjE3OTYyMDEzMTYsImlhdCI6MTc5MzYwOTMxNiwianRpIjoiZTQ0OTMxYmYtNjU0MC00NzQxLWIxY2EtM2ZmMDllY2IyZTZiIn0.RLVkpSORFpCQRF7NHtKI2lTrIS_s_gB8NML-uaA-Kio"

